import { FC } from 'react';
import { Button } from 'antd';
import { ImageTags } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/MobileUploadWizzard/components/common';
import { useTranslation } from 'react-i18next';
import { StyledDrawer } from './ImageTagsDrawer.styles';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ImageTagsDrawer: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <StyledDrawer {...props} placement="bottom" height="100%">
      <div className="image-tags-drawer-content">
        <p className="image-tags-drawer-title">{t('uploadImageTagsDrawerTitle')}</p>
        <ImageTags className='image-tags-list' />
        <Button className="image-tags-drawer-close-btn" size="large" type="primary" onClick={props.onClose}>
          {t('Close')}
        </Button>
      </div>
    </StyledDrawer>
  );
};
